module.exports = __webpack_public_path__ + "img/img3.3111d836.png";